var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { XCircle } from '@olxbr/ds-icons';
import { HelpTextDefaultProps } from './props';
import * as S from './styles';
/**
 * Componente HelpText do Design System OLX
 */
export const HelpText = _a => {
  var {
      children,
      isError
    } = _a,
    props = __rest(_a, ["children", "isError"]);
  if (isError) {
    Object.assign(props, {
      role: 'alert'
    });
  }
  return React.createElement(S.Container, Object.assign({
    "data-ds-component": "DS-HelpText",
    isError: isError
  }, props), isError && React.createElement(S.Icon, null, React.createElement(XCircle, {
    size: "16px"
  })), children);
};
HelpText.displayName = 'HelpText';
HelpText.defaultProps = HelpTextDefaultProps;